<template>
    <div class="voice-message-bubble">
        <div class="voice-content">
            <div class="voice-info">
                <div class="voice-duration">{{ formatDuration(duration) }}</div>
                <!--                <div v-if="text" class="voice-text">{{ text }}</div>-->
            </div>
            <button 
                class="play-button" 
                @click="togglePlay"
                :class="{ 'playing': isPlaying }"
            >
                <img
                    :src="require('@/assets/images/svg/voice.svg')"
                    class="microphone-icon"
                    alt="语音"
                />
            </button>


        </div>
        
        <audio 
            ref="audioElement" 
            :src="audioUrl" 
            @ended="onAudioEnded"
            @timeupdate="onTimeUpdate"
            preload="metadata"
        ></audio>
    </div>
</template>

<script>


export default {
    name: 'VoiceMessageBubble',
    props: {
        audioUrl: {
            type: String,
            required: true
        },
        duration: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isPlaying: false,
            currentTime: 0
        }
    },
    methods: {
        togglePlay() {
            const audio = this.$refs.audioElement
            if (this.isPlaying) {
                audio.pause()
                this.isPlaying = false
            } else {
                audio.play()
                this.isPlaying = true
            }
        },

        onAudioEnded() {
            this.isPlaying = false
            this.currentTime = 0
        },

        onTimeUpdate() {
            this.currentTime = this.$refs.audioElement.currentTime
        },

        formatDuration(seconds) {
            const mins = Math.floor(seconds / 60)
            const secs = Math.floor(seconds % 60)
            return `${mins}:${secs.toString().padStart(2, '0')}`
        }
    }
}
</script>

<style scoped>
.voice-message-bubble {
    max-width: 200px;
    margin: 4px 0;
}

.voice-content {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #4CAF50;
    border-radius: 18px;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
}

.voice-content:hover {
    background: #45a049;
    transform: translateY(-1px);
}

.play-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: rgb(76 175 80);
    border: none;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.play-button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.play-button.playing {
    background: rgba(255, 255, 255, 0.3);
}

.microphone-icon {
    width: 16px;
    height: 16px;
    filter: brightness(0) invert(1); /* 使图标变成白色 */
}

.voice-info {
    flex: 1;
    min-width: 0;
}

.voice-duration {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 2px;
}

.voice-text {
    font-size: 12px;
    opacity: 0.9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

audio {
    display: none;
}
</style>
